<ng-container [ngSwitch]="currentActionPanelView$ | async">
  <lex-translate-action-panel *ngSwitchCase="'translate'"></lex-translate-action-panel>
  <lex-split-doc-panel *ngSwitchCase="'split-document'"></lex-split-doc-panel>
  <lex-facts-and-issues-panel *ngSwitchCase="'facts-and-issues'"></lex-facts-and-issues-panel>
  <lex-doc-note-panel *ngSwitchCase="'document-notes'"></lex-doc-note-panel>
  <lex-export-document-panel *ngSwitchCase="'download'"></lex-export-document-panel>
  <lex-doc-compare-panel *ngSwitchCase="'compare-doc'"></lex-doc-compare-panel>
  <lex-hits-panel *ngSwitchCase="'hits'"></lex-hits-panel>
</ng-container>

<div class="tabs" style="display: flex; justify-content: space-between; height: 50px;">
  <div style="display: flex; height: 100%; width: 17%">
    <div *inRole="[roles.StandardFeatureSet, roles.DocReviewFeatureSet]" (click)="updateActionPanelView('document-notes')" class="icon-container" matTooltip="Notes"
         matTooltipPosition="above" [ngClass]="{'selected': (currentActionPanelView$ | async) === 'document-notes'}">
      <div class="fad fa-comment-dots"
           [ngClass]="{'selected-icon': (currentActionPanelView$ | async) === 'document-notes','icon': (currentActionPanelView$ | async) !== 'document-notes'}"></div>
    </div>
  </div>
  <div style="display: flex; height: 100%;"
       [ngClass]="{'selected': menuPanelViews.indexOf((currentActionPanelView$ | async)) !== -1}">
    <div *inRole="[roles.DocReviewFeatureSet, roles.EditFeatureSet, roles.Administrator]" class="icon-container" matTooltip="See more"
         matTooltipPosition="above"
         [matMenuTriggerFor]="actionBarMenu">
      <div class="fad fa-grid-2"
           [ngClass]="{'selected-icon': menuPanelViews.indexOf((currentActionPanelView$ | async)) !== -1, 'icon': menuPanelViews.indexOf((currentActionPanelView$ | async)) === -1}"></div>
    </div>
  </div>
</div>
<mat-menu class="doc-viewer-menu" #actionBarMenu yPosition="above">
  <menu mat-menu-item *ngIf="hasHits">
    <div (click)="updateActionPanelView('hits')" class="context-panel-title-container"
         style="display: flex; justify-content: left; align-items: center; gap: 5px;">
      <div class="context-panel-icon">
        <div class="fa-duotone fa-magnifying-glass reviewed-documents-title-header"></div>
      </div>
      <div>Hits</div>
    </div>
  </menu>
  <menu mat-menu-item>
    <div [style.width.px]="(390 - 32) * .75" (click)="updateActionPanelView('compare-doc')" class="context-panel-title-container"
         style="display: flex; justify-content: left; align-items: center; gap: 5px;">
      <div class="context-panel-icon">
        <div class="fa-duotone fa-code-compare reviewed-documents-title-header"></div>
      </div>
      <div>Compare with..</div>
    </div>
  </menu>
  <menu mat-menu-item *inRole="[roles.DocReviewFeatureSet]; negative: true">
    <div (click)="updateActionPanelView('split-document')" class="context-panel-title-container"
         style="display: flex; justify-content: left; align-items: center; gap: 5px;">
      <div class="context-panel-icon">
        <div class="fa-duotone fa-file-dashed-line reviewed-documents-title-header"></div>
      </div>
      <div>Split or Remove Pages</div>
    </div>
  </menu>
  <menu mat-menu-item>
    <div (click)="updateActionPanelView('facts-and-issues')" class="context-panel-title-container"
         style="display: flex; justify-content: left; align-items: center; gap: 5px;">
      <div class="context-panel-icon">
        <div class="fa-duotone fa-list-timeline reviewed-documents-title-header"></div>
      </div>
      <div>Manage Facts</div>
    </div>
  </menu>
  <menu mat-menu-item>
    <div (click)="updateActionPanelView('translate')" class="context-panel-title-container"
         style="display: flex; justify-content: left; align-items: center; gap: 5px;">
      <div class="context-panel-icon">
        <div class="fa-duotone fa-language reviewed-documents-title-header"></div>
      </div>
      <div>Translate</div>
    </div>
  </menu>
  <menu mat-menu-item>
    <div (click)="updateActionPanelView('download')" class="context-panel-title-container"
         style="display: flex; justify-content: left; align-items: center; gap: 5px;">
      <div class="context-panel-icon">
        <div class="fa-duotone fa-download reviewed-documents-title-header"></div>
      </div>
      <div>Download</div>
    </div>
  </menu>
</mat-menu>